import {
  chakraComponents,
  DropdownIndicatorProps,
  GroupBase,
} from 'chakra-react-select';
import { Option } from 'types/general.types';
import { ReactComponent as DropdownIcon } from 'resources/images/chevron-down.svg';
import React from 'react';

export const DropdownIndicator = (
  props: DropdownIndicatorProps<Option, false, GroupBase<Option>>
) => {
  const {
    isFocused,
    hasValue,
    selectProps: { isClearable },
  } = props;

  if (isFocused && hasValue && isClearable) {
    return null;
  }

  return (
    <chakraComponents.DropdownIndicator {...props}>
      <DropdownIcon />
    </chakraComponents.DropdownIndicator>
  );
};
